import React from 'react';
import { Card, List, Button, Tag, Typography } from 'antd';
import { formatPriceToman } from '../../../utils/formatPriceToman';
import {
  WarningFilled,
  ExclamationCircleFilled,
  ClockCircleFilled,
  ArrowLeftOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

const UrgentActions = ({ urgentActions, loading }) => {
  const navigate = useNavigate();

  if (!urgentActions) return null;

  const { 
    pending_approvals = [], 
    pending_refunds = [], 
    due_cheques = [] 
  } = urgentActions;

  // Combine actions into a single array for rendering
  const allActions = [
    ...pending_approvals.map(item => ({
      ...item,
      type: 'approval',
      title: 'واریزی نیازمند تایید',
      icon: <ClockCircleFilled className="text-amber-500" />,
      actionText: 'بررسی فیش',
      link: `/finance/approvals/${item.id}`
    })),
    ...pending_refunds.map(item => ({
      ...item,
      type: 'refund',
      title: 'درخواست عودت وجه',
      icon: <ExclamationCircleFilled className="text-red-500" />,
      actionText: 'تایید عودت',
      link: `/finance/refunds/${item.id}`
    })),
    ...due_cheques.map(item => ({
      ...item,
      type: 'cheque',
      title: 'چک سررسید شده',
      icon: <WarningFilled className="text-amber-600" />,
      actionText: 'تغییر وضعیت',
      link: `/finance/cheques/${item.id}`
    }))
  ];

  return (
    <Card 
      title={<span className="text-red-600 dark:text-red-400 font-semibold"><WarningFilled className="mr-2" /> اقدامات فوری</span>}
      loading={loading}
      bordered={false} 
      className="shadow-sm dark:bg-gray-800 rounded-2xl h-full"
    >
      {allActions.length === 0 ? (
        <div className="text-center py-8 text-gray-400">
          هیچ اقدام فوری در حال حاضر وجود ندارد.
        </div>
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={allActions}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button 
                  type="primary" 
                  size="small" 
                  ghost 
                  onClick={() => navigate(item.link)}
                  className="flex items-center gap-1 rounded-lg"
                >
                  {item.actionText} <ArrowLeftOutlined className="text-xs" />
                </Button>
              ]}
              className="hover:bg-gray-50 dark:hover:bg-gray-700/50 px-4 py-3 rounded-xl transition-colors mb-2 border border-gray-100 dark:border-gray-700"
            >
              <List.Item.Meta
                avatar={<div className="mt-1 text-lg">{item.icon}</div>}
                title={<Text className="font-medium dark:text-gray-200">{item.title}</Text>}
                description={
                  <div className="flex flex-col gap-1 mt-1">
                    <Text className="text-gray-500 text-xs">
                      {item.description || item.notes || `مربوط به معامله #${item.deal_id || 'نامشخص'}`}
                    </Text>
                    <Text className="text-gray-700 dark:text-gray-300 font-semibold text-sm">
                      مبلغ: {formatPriceToman(item.amount || 0)}
                    </Text>
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default UrgentActions;
